<template>
  <div>
    <vue-headful title="Vacaturelijst Organisatie" />
    <Header page_title="Vacaturelijst Organisatie" />
    <div class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-1 mb-2">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-1"
            role="tabpanel"
            aria-labelledby="pills-1-tab"
          >
            <div v-if="jobs">
              <form>
                <div class="mb-4 pb-2">
                  <div class="form-group w-square-icon mb-0">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Zoek vacature"
                        required
                      />
                      <div
                        class="icon-wrapper search position-absolute align-self-center"
                      >
                        <i class="material-icons">search</i>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="mb-4">
                <JobCard
                  v-for="job in jobs"
                  :key="job.id"
                  :job="job"
                  :job_ids="jobopen_ids"
                  :highlight="true"
                  :arrow="true"
                />
              </div>
              <div class="pt-1">
                <router-link
                  :to="{ name: 'job_step-1' }"
                  class="btn btn-warning btn-block"
                  >Nieuwe vacature plaatsen</router-link
                >
              </div>
            </div>
            <Empty v-else text="Er zijn geen banen beschikbaar." />
          </div>
          <div
            class="tab-pane fade"
            id="pills-2"
            role="tabpanel"
            aria-labelledby="pills-2-tab"
          >
            <div v-if="history">
              <form>
                <div class="mb-4 pb-2">
                  <div class="form-group w-square-icon mb-0">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Zoek vacature"
                        required
                      />
                      <div
                        class="icon-wrapper search position-absolute align-self-center"
                      >
                        <i class="material-icons">search</i>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="mb-4">
                <JobCard
                  v-for="job in history"
                  :key="job.id"
                  :job="job"
                  :job_ids="jobclosed_ids"
                  :arrow="true"
                  :closed="true"
                />
              </div>
            </div>
            <Empty v-else text="Je hebt geen vacatures in het archief." />
          </div>
        </div>
      </div>
    </div>
    <ul
      class="nav nav-pills nav-fill position-fixed w-100"
      id="pills-tab"
      role="tablist"
    >
      <li class="nav-item">
        <a
          class="nav-link active"
          id="pills-1-tab"
          data-toggle="pill"
          href="#pills-1"
          role="tab"
          aria-controls="pills-1"
          aria-selected="true"
        >
          Actief
          <span
            v-if="jobs"
            class="counter bg-white d-inline-block rounded-circle position-relative"
            >{{ jobs.length }}</span
          >
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="pills-2-tab"
          data-toggle="pill"
          href="#pills-2"
          role="tab"
          aria-controls="pills-2"
          aria-selected="false"
        >
          Historie
          <span
            v-if="history"
            class="counter bg-white d-inline-block rounded-circle position-relative"
            >{{ history.length }}</span
          >
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";

export default {
  data: function() {
    return {
      jobs: [],
      jobopen_ids: null,
      history: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.jobs = await this.getTokenAPIList("jobopen");
      if (this.jobs) {
        if (this.jobs.length > 1) {
          this.jobopen_ids = this.jobs.map(({ id }) => id);
        }
      }
      this.history = await this.getTokenAPIList("jobclosed");
      if (this.history) {
        if (this.history.length > 1) {
          this.jobclosed_ids = this.history.map(({ id }) => id);
        }
      }
      this.$store.state.loading = false;
    }
  },
  components: {
    JobCard
  }
};
</script>

<style scoped></style>
